module.exports = __webpack_public_path__ + "static/media/profile_default.9d64a2e3.jpg";